/* =============================================================
   dealer-signup.js — Trade account Sign Up page
   Scroll progress, IntersectionObserver reveal, hero stagger
   Relocates the live Hulk form into #dsu-form-mount
   ============================================================= */
(function () {
  'use strict';

  function initProgress() {
    var bar = document.querySelector('.dsu__progress');
    if (!bar) return;
    function update() {
      var doc = document.documentElement;
      var top = doc.scrollTop || document.body.scrollTop;
      var max = (doc.scrollHeight || document.body.scrollHeight) - doc.clientHeight;
      bar.style.width = (max > 0 ? Math.min(100, (top / max) * 100) : 0).toFixed(2) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initReveal() {
    var targets = document.querySelectorAll('.dsu-reveal');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initHeroStagger() {
    var els = document.querySelectorAll('.dsu__hero [data-stagger]');
    if (!els.length) return;
    els.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity 0.5s cubic-bezier(0.16,1,0.3,1), transform 0.5s cubic-bezier(0.16,1,0.3,1)';
      el.style.transitionDelay = (i * 0.1 + 0.1) + 's';
      setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 60);
    });
  }

  function isHulkFormSection(section) {
    if (!section || !section.querySelector) return false;
    return !!section.querySelector('.pxFormGenerator, iframe[src*="hulkapps"], .shopify-app-block');
  }

  function relocateForm() {
    var mount = document.getElementById('dsu-form-mount');
    if (!mount) return;
    var dsu = document.querySelector('.dsu');
    var dsuSection = dsu && dsu.closest('.shopify-section');
    if (!dsuSection) return;

    var candidate = dsuSection.nextElementSibling;
    while (candidate && candidate !== mount) {
      if (isHulkFormSection(candidate)) {
        mount.appendChild(candidate);
        return;
      }
      candidate = candidate.nextElementSibling;
    }
  }

  function init() {
    relocateForm();
    initProgress();
    initReveal();
    initHeroStagger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
